import { getRedDataApiPaths } from '../config'
import { BrandDetails } from '../redux/rewards/types'
import { ViewingRegion } from '../utils'
import { get } from '../utils/httpClient'

type BrandData = BrandDetails & {
  description: string
}

export type BrandsData = {
  brands: BrandData[]
}

export const data: BrandData[] = [
  {
    brandName: 'Virgin Atlantic',
    brandLogo: 'https://images.ctfassets.net/w2u6i2262322/3goEMMBN83p8H3lR1aAXL7/4d7479813416370dcb30326f7eac02e9/Virgin-Atlantic-logo.png',
    description: 'Taking off? Earn Virgin Points every time you travel. Spend points on reward seats, upgrades and more. Plane awesome.',
  },
  {
    brandName: 'Virgin Wines',
    brandLogo: 'https://images.ctfassets.net/w2u6i2262322/2CvXjIRwGsg6fVDzb4ceSU/7e0e042f3e44a0c8a20cf225d44b91be/virgin-wines_logo.png',
    description:
      'Calling all wine lovers and spirit drinkers. Spend and earn your Virgin Points to enjoy the exclusive tastes Virgin Wines has to offer.',
  },
  {
    brandName: 'Virgin Experience Days',
    brandLogo:
      'https://images.ctfassets.net/w2u6i2262322/7pqp5u951cNIERMUCztRGe/56a6da0532799e66fa003c4a01476edd/Virgin-Experience-Days_Logo.png?',
    description:
      'From tranquil spa retreats to exhilarating skydives and everything in between. Virgin Points are your passport to wild adventures and unforgettable moments.',
  },
  {
    brandName: 'AO Arena',
    brandLogo: 'https://images.ctfassets.net/w2u6i2262322/5BuRn1ADn4Kgprt6vvtHLm/9d304170e9f51bf8cfebb823755f86a7/ao-arena-logo.png?',
    description:
      "Party like there's no tomorrow in the Virgin Red Room at Manchester's AO Arena. You. A mate. Live Acts. Table Service. All night long.",
  },
  {
    brandName: 'Greggs',
    brandLogo: 'https://images.ctfassets.net/w2u6i2262322/4J2wBSaUU9Gxo2UZqi9sjT/02387998ff6744784d360fb97710b368/greggs.jpg',
    description:
      'Treat yourself to something delicious with Virgin Red! Use your Virgin Points to get your hands on a Greggs snack – from Sausage Rolls to Steak Bakes, doughnuts and more!',
  },
]

export const apiGetAllBrands = async (viewingRegion: ViewingRegion): Promise<BrandsData> =>
  await get(`${getRedDataApiPaths().RED_API_DISCOVERY_BRANDS}?viewingRegion=${viewingRegion}`, true)

export const apiGetSpecificBrandBySlug = (slug: string): BrandData | undefined =>
  data.find(({ brandName }) => slug === brandName.replaceAll(' ', '-').toLocaleLowerCase())
